export default function Impressum() {
  return (
    <div className="min-h-screen bg-[var(--page-bg)] text-[color:var(--page-fg)]">
      <main className="mx-auto max-w-5xl px-4 pb-16 pt-28 sm:px-6 md:pt-32">
        <div className="overflow-hidden rounded-[32px] border border-[#dbeafe] bg-white shadow-[0_24px_80px_rgba(29,78,216,0.08)]">
          <div className="border-b border-[#dbeafe] bg-[linear-gradient(135deg,rgba(29,78,216,0.08),rgba(147,197,253,0.18),rgba(255,255,255,1))] px-6 py-8 sm:px-8 lg:px-12">
            <span className="inline-flex items-center rounded-full border border-[#bfdbfe] bg-white/90 px-4 py-1 text-xs font-semibold uppercase tracking-[0.22em] text-[#1d4ed8] shadow-sm">
              Rechtliche Angaben
            </span>
            <h1 className="mt-4 text-3xl font-semibold leading-tight text-slate-900 md:text-4xl lg:text-5xl">
              Impressum
            </h1>
            <p className="mt-3 max-w-2xl text-sm leading-7 text-slate-600 sm:text-base">
              Anbieterkennzeichnung und gesetzlich erforderliche Informationen für Alltagsstern UG (haftungsbeschränkt).
            </p>
          </div>

          <div className="px-6 py-8 sm:px-8 lg:px-12 lg:py-10">
            <div className="prose prose-lg max-w-none prose-headings:font-semibold prose-headings:text-slate-900 prose-p:text-slate-700 prose-li:text-slate-700 prose-strong:text-slate-900 prose-a:text-[#1d4ed8] prose-a:underline hover:prose-a:no-underline">
              <h2 className="text-2xl font-semibold mb-4">Angaben gemäß § 5 DDG</h2>

              <div className="mb-8 rounded-3xl border border-[#dbeafe] bg-[#f8fbff] p-5 sm:p-6">
                <p className="mb-2">
                  <strong>Alltagsstern UG (haftungsbeschränkt)</strong>
                  <br />
                  vertreten durch den Geschäftsführer Furkan Yildiz
                  <br />
                  Wischmattenweg 14a
                  <br />
                  12357 Berlin
                  <br />
                  Deutschland
                  <br />
                  E-Mail:{' '}
                  <a href="mailto:info@alltagsstern.com" className="text-[#1d4ed8] hover:underline">
                    info@alltagsstern.com
                  </a>
                  <br />
                  Telefon:{' '}
                  <a href="tel:+4915229990328" className="text-[#1d4ed8] hover:underline">
                    +49 15229990328
                  </a>
                </p>
              </div>

              <h2 className="text-2xl font-semibold mb-4 mt-8">Vertreten durch</h2>
              <p className="mb-8">Furkan Yildiz</p>

              <h2 className="text-2xl font-semibold mb-4 mt-8">Registereintrag</h2>
              <p className="mb-8">
                Eingetragen im Handelsregister.
                <br />
                Registergericht: Amtsgericht Charlottenburg
                <br />
                Registernummer: HRB 284421 B
              </p>

              <h2 className="text-2xl font-semibold mb-4 mt-8">Inhaltlich verantwortlich gemäß § 18 Abs. 2 MStV</h2>
              <p className="mb-8">Furkan Yildiz, Wischmattenweg 14a, 12357 Berlin</p>

              <h2 className="text-2xl font-semibold mb-4 mt-8">Alternative Streitbeilegung</h2>
              <p className="mb-8">
                Wir sind nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>

              <h2 className="text-2xl font-semibold mb-4 mt-8">Haftung für Inhalte</h2>
              <p className="mb-4">
                Als Diensteanbieter sind wir gemäß den allgemeinen Gesetzen für eigene Inhalte auf diesen Seiten verantwortlich. Eine Verpflichtung zur Überwachung übermittelter oder gespeicherter fremder Informationen besteht nur im Rahmen der gesetzlichen Vorschriften.
              </p>
              <p className="mb-4">
                Bei Bekanntwerden konkreter Rechtsverletzungen werden wir entsprechende Inhalte umgehend entfernen.
              </p>

              <h2 className="text-2xl font-semibold mb-4 mt-8">Haftung für Links</h2>
              <p className="mb-4">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für diese fremden Inhalte übernehmen wir keine Gewähr. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.
              </p>
              <p className="mb-4">
                Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>

              <h2 className="text-2xl font-semibold mb-4 mt-8">Urheberrecht</h2>
              <p className="mb-4">
                Die auf dieser Website erstellten Inhalte und Werke unterliegen dem deutschen Urheberrecht. Jede Verwertung außerhalb der Grenzen des Urheberrechts bedarf der vorherigen schriftlichen Zustimmung.
              </p>
              <p className="mb-4">
                Sollten Sie dennoch auf eine mögliche Rechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir betroffene Inhalte umgehend entfernen.
              </p>

              <div className="mt-12 border-t border-[#dbeafe] pt-8">
                <p className="text-sm text-slate-500">Stand: März 2026</p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
